import { apiClient } from "@/lib/api/client";
import type { JsonObject } from "@/lib/api/types/json";

export type PlatformOverviewRecentTenantDto = {
  id: string;
  name: string;
  domain: string | null;
  is_active: boolean;
  created_at: string;
};

export type PlatformOverviewMapDeviceDto = {
  id: string;
  name: string | null;
  device_uid: string;
  status: string | null;
  is_active: boolean;
  last_seen: string | null;
  activity_status: string | null;
  activity_last_seen: string | null;
  activity_delay_label: string | null;
  tenant_name: string | null;
  metadata: JsonObject | null;
};

export type PlatformOverviewDto = {
  tenants_total: number;
  tenants_active: number;
  organizations_total: number;
  users_total: number;
  users_active: number;
  users_invited: number;
  users_disabled: number;
  super_admins_total: number;
  admins_total: number;
  distributors_total: number;
  end_users_total: number;
  devices_total: number;
  devices_active: number;
  devices_inactive: number;
  devices_warranty_expiring_this_month: number;
  devices_threshold_breached: number;
  map_devices: PlatformOverviewMapDeviceDto[];
  recent_tenants: PlatformOverviewRecentTenantDto[];
};

export type PlatformTopIngestingItemDto = {
  device_id: string;
  device_uid: string;
  name: string | null;
  tenant_name: string | null;
  status: string | null;
  last_seen: string | null;
  rows_ingested: number;
};

export type PlatformTopIngestingResponseDto = {
  range_key: string;
  start: string;
  end: string;
  total_rows: number;
  items: PlatformTopIngestingItemDto[];
};

export async function getPlatformOverview(params?: {
  alert_range_key?: "last_24h" | "last_7d" | "custom";
  alert_start?: string;
  alert_end?: string;
}): Promise<PlatformOverviewDto> {
  const { data } = await apiClient.get<PlatformOverviewDto>("/platform/overview", { params });
  return data;
}

export async function getWorkspaceOverview(params?: {
  alert_range_key?: "last_24h" | "last_7d" | "custom";
  alert_start?: string;
  alert_end?: string;
}): Promise<PlatformOverviewDto> {
  const { data } = await apiClient.get<PlatformOverviewDto>("/platform/workspace-overview", { params });
  return data;
}

export async function getPlatformTopIngesting(params: {
  range_key: "last_24h" | "last_7d" | "custom";
  start?: string;
  end?: string;
  limit?: number;
}): Promise<PlatformTopIngestingResponseDto> {
  const { data } = await apiClient.get<PlatformTopIngestingResponseDto>("/platform/top-ingesting", {
    params,
  });
  return data;
}

export async function getWorkspaceTopIngesting(params: {
  range_key: "last_24h" | "last_7d" | "custom";
  start?: string;
  end?: string;
  limit?: number;
}): Promise<PlatformTopIngestingResponseDto> {
  const { data } = await apiClient.get<PlatformTopIngestingResponseDto>("/platform/workspace-top-ingesting", {
    params,
  });
  return data;
}
